import { ONativeToken, TNativeToken, VAULT_CONTRACT } from 'modules/api';

export function getVaultAddress(selectedToken: TNativeToken): string {
  switch (selectedToken) {
    case ONativeToken.eBTC:
      return VAULT_CONTRACT;

    case ONativeToken.LBTC:
      return VAULT_CONTRACT;

    default:
      console.error('Vault address not available for this token');
      return '';
  }
}
